import { Button, Container, Dialog, Grid, Paper, Stack, Typography, Box } from '@mui/material';
import { FormProvider, SelectTag, TextField } from '../../../../../components';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { dropdownFetch, toast, BASE_URL } from '../../../../../utils';
import { useCallback, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';
import axios from 'axios';
import { SponsorWiseIpdReportPdf } from '../../../../Print/options/Hospital/HMS';


export const SponsorWiseIpdReport = () => {
  const [sponsorDropdown, setSponsorDropdown] = useState([]);
  const { pathname } = useLocation();
  const lastPathSegment = pathname.split('/').pop();
  const [openPrint, setOpenPrint] = useState(false);

  const getSponsorDropdown = useCallback(async () => {
    const data = await dropdownFetch('sponsor');
    setSponsorDropdown(data);
  }, []);

  useEffect(() => {
    getSponsorDropdown();
  }, [getSponsorDropdown]);

  const methods = useForm({
    resolver: yupResolver(
      Yup.object().shape({
        from_date: Yup.string().required(' ')
      })
    ),
    defaultValues: {
      from_date: new Date().toISOString().split('T')[0],
      to_date: new Date().toISOString().split('T')[0]
    },
    mode: 'all'
  });

  const { handleSubmit, watch, setValue, reset } = methods;

  const handleExcelReport = async () => {
    const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const fileExtension = '.xlsx';
    const response = await axios.get(`${BASE_URL}/print/hospital/inpatient-management/sponsor-wise-ipd-report?refId=${JSON.stringify({ sponsor: watch('sponsor'), from_date: watch('from_date'), to_date: watch('to_date') })}`)
     console.log("Response data :- ", response);
    if (response.data.success) {
    const filteredData = response?.data?.data || [];
      if (filteredData.length > 0) {
        console.log("If Condition Data :-", filteredData);

        const fileName = `Sponsor_Wise-Ipd_${watch('from_date')}_to_${watch('to_date')}`;

        const formattedData = filteredData.map((item, index) => ({
          "Sr. No.": index + 1,
          "UHID":item?.patients?.uhid ,

          'Ipd No': item?.ipd?.ipd_no,
          "Adm Date":item?.ipd?.date,
          "Adm Time ":item?.ipd?.time,  
          "Dis. Date":item?.ipd?.discharge_date,
          "Dis. Time ":item?.patientDischartDetails?.time,
          "Sponsor":item?.sponsor?.name,
          'Patient Name': (`${item?.patients?.name_suffix} ${item?.patients?.first_name} ${item?.patients?.last_name}`),
          'Age': (new Date().getFullYear() - new Date(item?.patients?.dob)?.getFullYear()),
          'Gender': item?.patients?.gender,
          'Address': item?.patients?.address?.address,

          'Adm Type': item?.ipd?.adm_type,
          'Doctor Name': item?.doctor?.name,
          "CareTaker-Name":`${item?.ipd?.care_taker.name_1||item?.ipd?.care_taker.name_2}`
,
          "CareTaker-Relation":`${item?.ipd?.care_taker.relation_1||item?.ipd?.care_taker.relation_2}`,
          "CareTaker-Mobile":`${item?.ipd?.care_taker.mobile_1|| item?.ipd?.care_taker.mobile_2}`,
          'Net Amount': (item?.patients?.total?.toFixed(2)),
        }));
        const ws = XLSX.utils.json_to_sheet(formattedData);
        const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        const data = new Blob([excelBuffer], { type: fileType });
        saveAs(data, fileName + fileExtension);
      }else{
        toast(`No Data Found For These Filter`, { variant: 'error' });
      }
    } else {
      toast(`Something Went Wrong`, { variant: 'error' });
    }
  };


  return (
    <>
      <Paper
        sx={{
          p: 0,
          flex: 1,
          borderRadius: 0,
          boxShadow: 'none',
          width: '100%',
          height: 'auto'
        }}
      >
        <Container
          sx={{
            mt: 1,
            border: '0px solid',
            borderColor: 'grey.300',
            borderRadius: 1,
            width: '100%',
            maxWidth: 'none',
            minWidth: '100%',
            boxSizing: 'border-box'
          }}
        >
          <FormProvider methods={methods}>
            <Stack
              direction="row"
              spacing={2}
              justifyContent="space-between"
              alignItems="center"
              sx={{
                mb: 1,
                borderBottom: '0px solid',
                borderColor: 'grey.300'
              }}
            >
              <Typography color="primary" variant="h3" sx={{ fontWeight: 600 }}>
                Sponsor Wise IPD Report
              </Typography>
              <Stack direction="row" justifyContent="flex-end" sx={{ mb: 3 }} spacing={1}>
                <Button
                  variant="contained"
                  id={`${lastPathSegment}Print`}
                  disabled={!watch('sponsor')}
                  onClick={() =>
                    window.open(
                      `/print${pathname}?refId=${JSON.stringify({ sponsor: watch('sponsor'), from_date: watch('from_date'), to_date: watch('to_date') })}`,
                      '_blank'
                    ) } >
                  View Pdf Report
                </Button>
                <Button
                  variant="contained"
                  id={`${lastPathSegment}Print`}
                  disabled={!watch('sponsor')}
                  onClick={handleExcelReport} >
                  View Excel Report
                </Button>
                <Button variant="contained">Exit</Button>
              </Stack>
            </Stack>
            <Box
              sx={{
                border: '0px solid gray',
                padding: 2,
                borderRadius: '8px',
                width: '60%',
                boxShadow: '0px 2px 10px #0099ff'
              }}
            >
              <Grid container spacing={2}>
                <Grid item xs={11} sx={{ display: 'flex', gap: 0.3, flexDirection: 'column' }}>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.2, fontWeight: 700, fontSize: '1.4rem' }}>From Date</Typography>
                    <TextField sx={{ flex: 0.8 }} name="from_date" type="date" />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.2, fontWeight: 700, fontSize: '1.4rem' }}>To Date</Typography>
                    <TextField sx={{ flex: 0.8 }} name="to_date" type="date" />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 3 }}>
                    <Typography sx={{ flex: 0.2, fontWeight: 700, fontSize: '1.4rem' }}>Sponsor</Typography>
                    <SelectTag
                      formControlSX={{ flex: 0.8 }}
                      name="sponsor"
                      menus={[{ _id: 'all', name: 'All' }, ...sponsorDropdown]}
                    />
                  </Stack>
                </Grid>
              </Grid>
            </Box>
          </FormProvider>
        </Container>
      </Paper>
      <Dialog
        open={openPrint}
        onClose={() => setOpenPrint(false)}
        PaperProps={{ sx: { width: '80%', height: '85%', p: 2 } }}
        maxWidth="xl"
        scroll="body"
      >
        <SponsorWiseIpdReportPdf />
      </Dialog>
    </>
  );
};
